import React from 'react';
import {List} from 'react-md';
import NavLink from './../../atoms/navLink';
import _ from 'lodash';

const subPages = [
  {
    label: 'Préstamos',
    to: '/reports/',
  },
//  {
//    label: 'Uso del Sistema',
//    to: '/reports/users',
//  },
  {
    label: 'Dispositivos',
    to: '/reports/devices',
  },
  {
    label: 'Programa Académico',
    to: '/reports/academics',
  },
];

const ReportsLink = ({}) => {
  return (
    <List className="md-paper md-paper--1" inline>
      {_.map(subPages, ({label, to}, key) => (
        <li className="md-list-item" key={key}>
          <NavLink exact="true" to={to} label={label}/>
        </li>
      ))}
    </List>
  );
};

export default ReportsLink;



// WEBPACK FOOTER //
// ./src/components/atoms/subNavs/reportsNav.js